import type { FormConfig } from '../types';
import lineManagerConversation from '../pages/gdad/lineManagerConversation';
import roleSelection from '../pages/gdad/roleSelection';
import yourDetails from '../pages/gdad/yourDetails';

const formConfig: FormConfig = {
  live: true,
  id: 'gdad',
  formName: 'GDAD Assessment',
  title: 'Cabinet Office GDAD Assessment',
  subTitle: 'Summary page',
  identifier: '{full-name}, {role-level}',
  formCloseAt: '2026-06-01',
  strictDeadline: true,
  showSections: true,
  approval: 'always',
  approvalAllowUnsubmit: true,
  register: true,
  sections: [
    {
      title: 'Your Details',
      slug: 'your-details',
      subsections: [
        {
          title: 'Your Details',
          slug: 'your-details',
          pages: yourDetails,
        },
        {
          title: 'Role Selection',
          slug: 'role-selection',
          pages: roleSelection,
        },
      ],
    },
    {
      title: 'Skills Assessment',
      slug: 'skills-assessment',
      dependsOn: 'your-details',
      subsections: [
        {
          title: 'Skills Assessment',
          slug: 'skills-assessment',
          pages: [],
          dynamicPages: {
            type: 'gdadSkillsByRoleLevel',
            roleField: 'role',
            roleLevelField: 'role-level',
          },
        },
      ],
    },
    {
      title: 'Proficiency Rating',
      slug: 'proficiency-rating',
      subsections: [
        {
          title: 'Line Manager Conversation',
          slug: 'line-manager-conversation',
          pages: lineManagerConversation,
        },
      ],
    },
  ],
};

export default formConfig;

